// extracted by mini-css-extract-plugin
export default {"content":"tooltip_content__SoIZp","hover":"tooltip_hover__yVAQn","click":"tooltip_click__ekWlS","arrow":"tooltip_arrow__z6ojq","tooltip":"tooltip_tooltip__gWzxw"};